var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandheldScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "374.5pt",
    height: "349.62659pt",
    viewBox: "0 0 374.5 349.62659",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,-63,407.6266)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2402,4071 c -78,-6 -86,-8 -112,-38 -65,-73 -97,-275 -66,-417 21,-91 72,-198 124,-257 l 39,-43 159,-8 c 451,-22 498,-31 575,-108 87,-87 83,-44 87,-938 2,-511 -1,-796 -8,-821 -13,-51 -50,-95 -139,-167 -42,-33 -85,-76 -95,-94 -27,-45 -25,-118 3,-164 49,-79 137,-99 256,-59 33,12 159,51 280,88 121,37 236,77 256,90 52,34 70,80 80,209 10,123 59,849 89,1304 18,274 21,296 46,352 32,72 77,115 176,169 105,58 149,99 189,177 32,65 34,73 34,173 0,94 -3,113 -26,162 -60,128 -160,185 -450,258 -207,53 -424,92 -647,117 -147,17 -702,27 -850,15 z m 1031,-146 c 131,-34 315,-161 305,-211 -6,-33 -37,-26 -94,21 -116,94 -218,135 -339,135 -120,0 -216,-38 -322,-127 -58,-48 -86,-52 -91,-13 -5,47 161,162 281,195 69,18 189,19 260,0 z m -24,-181 c 95,-28 217,-121 209,-160 -6,-33 -36,-27 -95,19 -95,73 -117,82 -213,82 -95,0 -139,-17 -210,-81 -42,-38 -82,-43 -88,-11 -5,23 28,58 92,99 102,66 202,83 305,52 z m -24,-164 c 41,-26 59,-68 52,-123 -15,-111 -171,-136 -223,-36 -57,111 65,224 171,159 z m 599,-296 c 20,-20 12,-35 -49,-94 -46,-45 -84,-107 -112,-184 -16,-45 -36,-318 -79,-1086 -15,-272 -31,-491 -37,-498 -6,-7 -20,-12 -31,-10 -20,3 -21,9 -19,108 1,105 41,822 68,1230 16,244 31,310 93,406 34,53 125,144 144,144 4,0 14,-7 22,-16 z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3288,3519 c -21,-12 -24,-59 -6,-77 7,-7 24,-12 38,-12 14,0 31,5 38,12 7,7 12,24 12,38 0,45 -40,64 -82,39 z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1030,3715 v -35 h 145 145 v 35 35 h -145 -145 z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1450,3560 v -190 h 180 180 v 190 190 h -180 -180 z m 290,0 v -120 h -110 -110 v 120 120 h 110 110 z",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 710,3710 c 0,-26 3,-30 29,-30 21,0 30,6 34,22 8,30 1,38 -34,38 -26,0 -29,-3 -29,-30 z",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 860,3640 v -100 h 35 35 v 100 100 h -35 -35 z",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1320,3575 c 0,-34 1,-35 40,-35 39,0 40,1 40,35 0,34 -1,35 -40,35 -39,0 -40,-1 -40,-35 z",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1000,3535 v -35 h 55 55 v 35 35 h -55 -55 z",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 710,3440 v -100 h 34 33 l 1,83 c 2,106 -2,117 -39,117 h -29 z",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1230,3385 c 0,-45 0,-45 35,-45 35,0 35,0 35,45 0,45 0,45 -35,45 -35,0 -35,0 -35,-45 z",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 940,3355 v -65 h 35 35 v 65 65 h -35 -35 z",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1082,3288 c 3,-32 5,-33 48,-33 43,0 45,1 48,33 l 3,32 h -51 -51 z",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1410,3220 v -100 h 35 35 v 100 100 h -35 -35 z",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 720,3225 v -35 h 90 90 v 35 35 h -90 -90 z",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1650,3225 v -35 h 76 75 l -3,33 -3,32 -72,3 -73,3 z",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1260,3159 v -60 l 33,3 c 32,3 32,4 35,61 l 3,57 h -36 -35 z",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2917,3151 c 32,-62 37,-81 37,-140 0,-55 -5,-79 -27,-121 -15,-28 -25,-56 -22,-60 3,-5 21,-14 41,-20 54,-18 114,-55 156,-96 l 38,-37 v 164 c 0,118 -4,178 -16,219 -26,93 -86,142 -194,156 l -49,7 z",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1100,3070 v -100 h 35 35 v 100 100 h -35 -35 z",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 910,3125 v -35 h 55 55 v 35 35 h -55 -55 z",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 700,3085 v -35 h 75 75 v 35 35 h -75 -75 z",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1570,3085 c 0,-32 2,-35 30,-35 28,0 30,3 30,35 0,32 -2,35 -30,35 -28,0 -30,-3 -30,-35 z",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1727,3083 c -4,-3 -7,-35 -7,-70 v -63 h 35 35 v 70 70 h -28 c -16,0 -32,-3 -35,-7 z",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 660,2825 v -185 h 175 175 v 185 185 H 835 660 Z m 280,0 V 2710 H 835 730 v 115 115 h 105 105 z",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1292,2978 3,-33 73,-3 72,-3 v 36 35 h -76 -75 z",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1600,2850 v -60 h 35 35 v 60 60 h -35 -35 z",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1332,2848 3,-33 88,-3 87,-3 v 36 35 h -91 -90 z",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1127,2853 c -4,-3 -7,-19 -7,-35 0,-27 1,-28 55,-28 h 55 v 35 35 h -48 c -27,0 -52,-3 -55,-7 z",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1740,2820 c 0,-39 1,-40 35,-40 34,0 35,1 35,40 0,39 -1,40 -35,40 -34,0 -35,-1 -35,-40 z",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1080,2665 c 0,-35 0,-35 45,-35 45,0 45,0 45,35 0,35 0,35 -45,35 -45,0 -45,0 -45,-35 z",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1330,2665 v -35 h 70 70 v 35 35 h -70 -70 z",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1600,2665 v -36 l 98,3 97,3 v 30 30 l -97,3 -98,3 z",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 630,1615 v -435 h 25 25 v 435 435 h -25 -25 z",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 770,1615 v -435 h 35 35 v 435 435 h -35 -35 z",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 940,1615 v -435 h 25 25 v 435 435 h -25 -25 z",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1070,1615 v -435 h 45 45 v 435 435 h -45 -45 z",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1240,1610 v -440 h 25 25 v 440 440 h -25 -25 z",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1370,1615 v -435 h 50 50 v 435 435 h -50 -50 z",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1550,1615 v -435 h 25 25 v 435 435 h -25 -25 z",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1680,1615 v -435 h 45 45 v 435 435 h -45 -45 z",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1860,1615 c 0,-428 0,-435 20,-435 20,0 20,7 20,435 0,428 0,435 -20,435 -20,0 -20,-7 -20,-435 z",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3590,1001 c -28,-8 -24,19 -44,-318 l -7,-103 h 51 50 v 215 c 0,229 2,221 -50,206 z",
    id: "path98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandheldScan);
export default __webpack_public_path__ + "static/media/handheldScan.2f57a9c5.svg";
export { ForwardRef as ReactComponent };